import { render, staticRenderFns } from "./Agreengl.vue?vue&type=template&id=4a87f13e&scoped=true"
import script from "./Agreengl.vue?vue&type=script&lang=js"
export * from "./Agreengl.vue?vue&type=script&lang=js"
import style0 from "./Agreengl.vue?vue&type=style&index=0&id=4a87f13e&prod&lang=css"
import style1 from "./Agreengl.vue?vue&type=style&index=1&id=4a87f13e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87f13e",
  null
  
)

export default component.exports